import React from "react";

const ContactInfo = () => {
  return (
    <>
      <div className="contact-info">
        <h4>How can I help? <br /> Get in touch</h4>
        <ul>
          <li className="media">
            <i className="icon icon-map"></i>
            <span className="media-body">
              Spokane WA
            </span>
          </li>
          {/* End li */}

          {/*<li className="media">
            <i className="icon icon-envelope"></i>
            <span className="media-body">ernestmena@gmail.com</span>
          </li>*/}
          {/* End li */}
        </ul>
      </div>
      {/* End .contact-info */}
    </>
  );
};

export default ContactInfo;
